import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../features/auth/services/auth.service';
import {
  hasAnyRole,
  rolesFromAccessToken,
} from '../helpers/jwt-payload.helper';
import {
  destinationForRoles,
  navigateToDestination,
} from '../helpers/app-destination.helper';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  #router = inject(Router);
  #authService = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const token = this.#authService.accessToken();
    if (!token) {
      return this.#router.createUrlTree(['/auth']);
    }

    const userRoles = rolesFromAccessToken(token);
    if (userRoles.length === 0) {
      this.#authService.clearSession();
      return this.#router.createUrlTree(['/auth']);
    }

    const requiredRoles = route.data['roles'] as string[] | undefined;
    if (hasAnyRole(userRoles, requiredRoles)) {
      return true;
    }

    const destination = destinationForRoles(userRoles);
    if (destination) {
      navigateToDestination(destination);
      return false;
    }

    this.#authService.clearSession();
    return this.#router.createUrlTree(['/auth']);
  }
}
